import { EmptyState } from '../../shared/ui';
import { PageHeader } from '../AdminShell';

/** Placeholder. The layout is real; the surface is not built yet. */
export default function AdminSettings() {
  return (
    <>
      <PageHeader title="Settings" description="Configuration for this academy." />
      <EmptyState title="Not built yet" body="Tenant settings will live here." />
    </>
  );
}
